// CronScheduler.jsx
import { useState, useEffect, useCallback } from "react";
// import awsCronParser from "aws-cron-parser";
import awsCron from "common/utils/awsCron";
import "./CronScheduler.css";
// import { epochToTimestamp } from "common/utils/getNextCronTime";
import Checkbox from "../Checkbox";
import ActionButton from "../ActionButton";
import MultiSelect from "../MultiSelect";
import Input from "../Input";
import { Chip } from "@mui/material";
const parseCronExpression = (cron) => {
  const [minute, hour, dayOfMonth, month, dayOfWeek, year] = cron.split(" ");

  return {
    time: `${hour}:${minute}`,
    days: dayOfMonth.split(","),
    daysW: dayOfWeek
      .split(",")
      .map(
        (day) =>
          ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][parseInt(day) - 1]
      ),
    months: month === "*" ? [] : month.split(","),
  };
};

const CronScheduler = ({
  schedule = null,
  onSubmit = (data) => console.log(data),
}) => {
  const [frequency, setFrequency] = useState("once");
  const [time, setTime] = useState("00:00");
  const [days, setDays] = useState([]);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [months, setMonths] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timezone, setTimezone] = useState("");
  const [manualMode, setManualMode] = useState(false);
  const [cronExpression, setCronExpression] = useState("* * * * ? *");
  // Get browser timezone on mount
  useEffect(() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      setTimezone(tz);
    } catch (error) {
      console.warn("Unable to detect timezone, falling back to UTC");
      setTimezone("UTC");
    }
  }, []);
  //populate default form values
  useEffect(() => {
    if (schedule?.cron?.frequency == "manual") {
      setManualMode(true);
      setCronExpression(schedule?.cron?.expression);
      return;
    }
    if (schedule?.cron?.frequency == "once") {
      setDate(
        schedule?.cron?.expression.split("T")[0] ||
          new Date().toISOString().split("T")[0]
      );
      setTime(schedule?.cron?.expression.split("T")[1]);
      setFrequency("once");
      return;
    }
    if (schedule?.cron?.expression) {
      const parsedCron = parseCronExpression(schedule?.cron?.expression);
      setFrequency(schedule?.cron?.frequency);
      setTime(parsedCron.time);
      setDays(parsedCron.daysW);
      setMonths(parsedCron.days);
    }
  }, [schedule]);
  // Validate cron expression format
  // const validateCronExpression = (expression) => {
  //   try {
  //     let timestamp = new Date();
  //     let cron = awsCronParser.parse(expression.trim());
  //     timestamp = awsCronParser.next(cron, timestamp);
  //     return epochToTimestamp(Date.parse(timestamp) / 1000);
  //   } catch {
  //     return false;
  //   }
  // };
  const validateCronExpression = (expression) => {
    try {
      let cron = awsCron.parse(expression.trim());
      let nextOccurrence = awsCron.next(cron, new Date());
      return nextOccurrence;
    } catch (error) {
      return null;
    }
  };

  const constructCronExpression = () => {
    let awsCron = "";
    const [hour, minute] = time.split(":");
    if (manualMode) {
      return cronExpression;
    } else {
      switch (frequency) {
        case "once": // New case for "once" frequency
          // awsCron = `${minute} ${hour} * * ? *`; // Same as daily, but will only run once
          awsCron = `${date}T${hour}:${minute}:00`; // Same as daily, but will only run once
          break;
        case "daily":
          awsCron = `${minute} ${hour} * * ? *`;
          break;
        case "weekly":
          awsCron = `${minute} ${hour} ? * ${days
            .map(
              (day) =>
                ["sun", "mon", "tue", "wed", "thu", "fri", "sat"].indexOf(day) +
                1
            )
            .join(",")} *`;
          break;
        case "monthly":
          awsCron = `${minute} ${hour} ${months.join(",")} * ? *`;
          break;
      }
      return awsCron;
    }
  };
  const handleSave = useCallback(async () => {
    setIsLoading(true);

    try {
      let awsCron = "";

      if (!manualMode) {
        awsCron = constructCronExpression();
      } else {
        if (!validateCronExpression(cronExpression)) {
          throw new Error("Invalid cron expression format");
        }
        awsCron = cronExpression;
      }

      onSubmit({
        expression: awsCron,
        timezone: timezone,
        frequency: manualMode ? "manual" : frequency,
      });
    } catch (error) {
      console.error("Failed to save cron expression:", error.message);
    } finally {
      setIsLoading(false);
    }
  }, [
    time,
    days,
    months,
    date,
    frequency,
    manualMode,
    cronExpression,
    onSubmit,
    timezone,
  ]);
  return (
    <div className="cron-scheduler">
      <div className="mode-toggle">
        <Checkbox
          text="Manual Input"
          value={manualMode}
          onChange={(value) => {
            setManualMode(value);
          }}
          id="manual-input-toggle"
        />
        {/* <label className="switch">
          <input
            type="checkbox"
            checked={manualMode}
            onChange={(e) => setManualMode(e.target.checked)}
          />
          <span className="slider round"></span>
        </label>
        <span>Manual Input</span> */}
      </div>

      {!manualMode && (
        <>
          <MultiSelect
            dark
            options={["Once", "Daily", "Weekly", "Monthly"]}
            size="small"
            ChipProps={{ size: "small" }}
            multiple={false}
            label="Frequency"
            shrink
            value={frequency[0].toUpperCase() + frequency.slice(1)}
            setValue={(e) => {
              setFrequency(e?.toLowerCase());
              setDays([]);
              setMonths([]);
            }}
          />
          {/* <label>
            <b>Select Frequency:</b>
          </label>
          <select
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              setDays([]);
              setMonths([]);
            }}
          >
            <option value="once">Once</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select> */}

          <label>
            <b>
              {frequency === "once"
                ? "Select Date and Time"
                : frequency === "daily"
                ? "Select Time"
                : frequency === "weekly"
                ? "Select Time and Days"
                : "Select Time and Dates"}
            </b>
          </label>
          {frequency === "once" ? (
            <>
              <Input
                dark
                size="small"
                label="Date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                placeholder="YYYY/MM/DD"
                type="date"
              />
              <Input
                dark
                size="small"
                label="Time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                type="time"
              />
              {/* <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                placeholder="YYYY/MM/DD"
              /> */}
              {/* <input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              /> */}
            </>
          ) : (
            <Input
              dark
              size="small"
              label="Time"
              value={time}
              onChange={(e) => setTime(e.target.value)}
              type="time"
            />
          )}

          {frequency === "weekly" && (
            <div className="day-selector">
              {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map((day) => (
                <div
                  key={day}
                  className={`day ${days.includes(day) ? "selected" : ""}`}
                  onClick={() =>
                    setDays((prev) =>
                      prev.includes(day)
                        ? prev.filter((d) => d !== day)
                        : [...prev, day]
                    )
                  }
                >
                  {day[0].toUpperCase() + day.slice(1, 2)}
                </div>
              ))}
            </div>
          )}

          {frequency === "monthly" && (
            <div className="day-selector">
              {Array.from({ length: 31 }).map((_, index) => (
                <div
                  key={index}
                  className={`day ${
                    months.includes(String(index + 1)) ? "selected" : ""
                  }`}
                  onClick={() =>
                    setMonths((prev) =>
                      prev.includes(String(index + 1))
                        ? prev.filter((m) => m !== String(index + 1))
                        : [...prev, String(index + 1)]
                    )
                  }
                >
                  {index + 1}
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {manualMode && (
        <>
          <Input
            dark
            size="small"
            label="Cron Expression"
            value={cronExpression}
            onChange={(e) => setCronExpression(e.target.value)}
          />
          <div className="timezone-info">
            <Chip
              sx={{ fontWeight: "bold" }}
              label={`Next run:
            ${validateCronExpression(
              cronExpression,
              timezone
            )?.toLocaleString() || "Invalid Cron"}`}
            ></Chip>
          </div>
        </>
      )}

      <div className="timezone-info">
        <Chip
          sx={{ backgroundColor: "#171717", fontWeight: "bold" }}
          label={`Timezone: ${timezone}`}
        ></Chip>
      </div>
      <div
        style={{
          marginTop: "10px",
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <ActionButton
          icon={"schedule"}
          dark
          noload
          disabled={
            isLoading || (manualMode && !validateCronExpression(cronExpression))
          }
          handler={handleSave}
        >
          {"Save Schedule"}
        </ActionButton>
      </div>
      {/* <button
        className={`save-button ${isLoading ? "loading" : ""}`}
        onClick={handleSave}
        disabled={
          isLoading || (manualMode && !validateCronExpression(cronExpression))
        }
      >
        {isLoading ? "Saving..." : "Save Schedule"}
      </button> */}
    </div>
  );
};

export default CronScheduler;
